/**
 * Banner 3 — HeroCarousel
 * Per slide: desktop + optional mobile full-bleed backgrounds; programme `programs_json`;
 * accreditation = FILE uploads (`accreditation_logo_1`…3 + alts).
 */

export const BANNER_4_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Carousel slides",
  },

  DEFAULT_ROW: {
    id: "1",
    image: "",
    alt_image: "banner-bg",
    mobile_image: "",
    mobile_alt_image: "banner-bg-mobile",
    title_line1: "IIT Kharagpur",
    title_line1_accent: "IIT Kharagpur",
    title_line2: "Dedicated to the service of the Nation",
    merge_title_lines: false,
    subtitle: "Pioneering Technical Education Since 1951",
    hero_right_image: "",
    alt_hero: "banner",
    programs_json: `[
  {"label": "Programme A", "href": "program-slug-a"},
  {"label": "Programme B", "href": "program-slug-b"}
]`,
    accreditation_logo_1: "",
    accreditation_logo_1_alt: "",
    accreditation_logo_2: "",
    accreditation_logo_2_alt: "",
    accreditation_logo_3: "",
    accreditation_logo_3_alt: "",
    title_line1_accent_color: "",
    title_line1_color: "",
    title_line2_color: "",
    subtitle_color: "",
    priority: 1,
    status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "slide_frequency",
      label: "Slide interval (ms)",
      value: 7000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "7000",
      required: true,
      defaultValue: 7000,
    },
    {
      fieldName: "hero_section_height",
      label: "Section height (px)",
      value: 564,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "564",
      defaultValue: 564,
    },
    {
      fieldName: "hero_container_max_width",
      label: "Content max width (px)",
      value: 1114,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1114",
      defaultValue: 1114,
    },
    {
      fieldName: "background_color",
      label: "Right vertical accent strip (slides use full-width background + this strip)",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#291973",
    },
    {
      fieldName: "hero_info_bar_show",
      label: "Show hero info bar (above title line 1)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "hero_info_bar_text",
      label: "Hero info bar copy",
      value:
        "8 Months ✦ 100% Live Online ✦ Batch Start Date: 30 June 2026",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "8 Months ✦ 100% Live Online ✦ Batch Start Date: 30 June 2026",
      defaultValue:
        "8 Months ✦ 100% Live Online ✦ Batch Start Date: 30 June 2026",
    },
    {
      fieldName: "apply_now_show",
      label: "Show primary CTA (Get in Touch)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "Primary CTA label",
      value: "Get in Touch",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Get in Touch",
      defaultValue: "Get in Touch",
    },
    {
      fieldName: "apply_now_link",
      label: "Primary CTA URL (Get in Touch)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/contact or https://… (used when Is CTA is off)",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "Is CTA — Primary (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = open lead capture popup instead of Primary CTA URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "button_color",
      label: "Primary CTA background",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#291973",
    },
    {
      fieldName: "apply_now_color",
      label: "Primary CTA text color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#ffffff",
    },
    {
      fieldName: "download_brochure_show",
      label: "Show Download Brochure button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "download_brochure_text",
      label: "Download Brochure label",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Download Brochure",
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "download_brochure_link",
      label:
        "Download Brochure URL (optional — when Is CTA is off + empty, uses lead form + course brochure)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://…/brochure.pdf",
      defaultValue: "",
    },
    {
      fieldName: "download_brochure_is_cta",
      label: "Is CTA — Brochure (lead popup / download flow)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = open brochure lead flow instead of direct brochure URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "application_deadline_show",
      label: "Show application deadline line",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "application_deadline_text",
      label: "Application deadline copy",
      value: "Application Deadline – 20 Apr",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Application Deadline – 20 Apr",
      defaultValue: "Application Deadline – 20 Apr",
    },
    {
      fieldName: "carousel_color",
      label: "Carousel dot (active)",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#ffffff",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Slide background (desktop)",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Desktop background image",
      defaultValue: "",
    },
    {
      header: "Background alt (desktop)",
      fieldName: "alt_image",
      value: "banner-bg",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "banner-bg",
    },
    {
      header: "Slide background (mobile)",
      fieldName: "mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Mobile background image (optional — uses desktop if empty)",
      defaultValue: "",
    },
    {
      header: "Background alt (mobile)",
      fieldName: "mobile_alt_image",
      value: "banner-bg-mobile",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "banner-bg-mobile",
    },
    {
      header: "Title line 1",
      fieldName: "title_line1",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title line 1 (accent span)",
      fieldName: "title_line1_accent",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Highlighted part (e.g. IIT Kharagpur)",
      defaultValue: "",
    },
    {
      header: "Title line 2 (headline)",
      fieldName: "title_line2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Merge title lines 1 + 2 (single continuous headline)",
      fieldName: "merge_title_lines",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "Off = line 2 on its own row; On = line 2 continues after line 1 in one heading",
      defaultValue: false,
    },
    {
      header: "Subtitle",
      fieldName: "subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title line 1 — accent colour",
      fieldName: "title_line1_accent_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty for default (yellow / primary)",
      defaultValue: "",
    },
    {
      header: "Title line 1 — rest / full line colour",
      fieldName: "title_line1_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "When accent split: non-accent part; else full line 1",
      defaultValue: "",
    },
    {
      header: "Title line 2 colour",
      fieldName: "title_line2_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "",
    },
    {
      header: "Subtitle colour",
      fieldName: "subtitle_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "",
    },
    {
      header: "Hero image (center)",
      fieldName: "hero_right_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Center hero image",
      defaultValue: "",
    },
    {
      header: "Hero image alt",
      fieldName: "alt_hero",
      value: "banner",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "banner",
    },
    {
      header: "Programme buttons (JSON)",
      fieldName: "programs_json",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: `[{"label":"Programme A","href":"/programme-a"},{"label":"Programme B","href":"/programme-b"}]`,
      defaultValue: "",
      rows: 5,
    },
    {
      header: "Accreditation logo 1",
      fieldName: "accreditation_logo_1",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo",
      defaultValue: "",
    },
    {
      header: "Accreditation logo 1 alt",
      fieldName: "accreditation_logo_1_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Accreditation logo 2",
      fieldName: "accreditation_logo_2",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo",
      defaultValue: "",
    },
    {
      header: "Accreditation logo 2 alt",
      fieldName: "accreditation_logo_2_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Accreditation logo 3",
      fieldName: "accreditation_logo_3",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo",
      defaultValue: "",
    },
    {
      header: "Accreditation logo 3 alt",
      fieldName: "accreditation_logo_3_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
